/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import DismissableBanner from '../../components/dismissable-banner';
import LoadingIndicator from '../../components/loading-indicator';
import LoginForm from '../../containers/login-form';
import Logo from '../../components/logo';
import Footer from '../../components/footer';
import {authRequestLogin} from '../../store/auth/actions';
import {isLoggedIn} from '../../store/auth/selectors';
import {getRequestError, isRequestRunning} from '../../store/requests/selectors';
import {authCheckLogin, getConfig} from "../../store/auth/actions";

const LoginWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

class Login extends React.Component {
    componentDidUpdate(oldProps) {
        if (oldProps.loggedIn !== this.props.loggedIn) {
            this.props.history.push('/');
        }
        const {authCheckLogin, getConfig} = this.props;
        // console.log("this.porps", this.props);
        authCheckLogin();
        getConfig();
    }

    componentDidMount() {
        const {authCheckLogin} = this.props;
        // console.log("this.porps", this.props);
        authCheckLogin();
    }

    render() {
        return (
            <LoginWrapper>
                {this.props.loginError && <DismissableBanner message={this.props.loginError}/>}
                {this.props.isLoggingIn && <LoadingIndicator/>}

                <div>
                    <Logo/>

                    <LoginForm/>
                </div>

                <Footer/>
            </LoginWrapper>
        );
    }
}

export default connect(
    (state) => ({
        isLoggingIn: isRequestRunning(state, authRequestLogin),
        loginError: getRequestError(state, authRequestLogin),
        loggedIn: isLoggedIn(state),
    }), {
        authCheckLogin,
        getConfig
    }
)(Login);



// WEBPACK FOOTER //
// ./src/pages/login/index.js